import styled, { css } from 'styled-components'
import { NoPaddingGrid } from 'Components/EnhacedFlexboxGrid'
import TitleValueBlockV2 from 'Layout/TitleValueBlockV2'

import { OUTLINE_COLOR, CLICKABLE_COLOR, LINK_COLOR, SELECTED_ITEM_BG_COLOR, FONT_BASE_COLOR } from '@CSSVars/colors'

export const _FeaturesBlock = styled.div`
  margin: 32px 0 28px;

  @media screen and (max-width: 768px) {
    margin: 24px 0;
    padding-bottom: 16px;
  }
`

export const _Title = styled.div`
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: 600;
`

const titleValueBlockCss = css`
  padding: 5px 0 4px;
  margin: 0 6px!important;
  flex-basis: calc(50% - 12px);
  flex-shrink: 1;
  border-top: 1px solid ${OUTLINE_COLOR};

  &:nth-child(1), &:nth-child(2) {
    border-top: none;
  }

  > div {
    width: 50%;
  }
  div {
    padding: 0!important;
    margin: 0!important;
    line-height: 24px;
    font-weight: 500!important;
  }
  a {
    padding-left: 0!important;
    line-height: 24px;
    font-weight: 500!important;
    text-align: left!important;
    color:  ${({ isMobileApp }) => (isMobileApp ? FONT_BASE_COLOR : LINK_COLOR)} !important;
    text-decoration:  ${({ isMobileApp }) => (isMobileApp ? 'none !important' : 'underline')};
    pointer-events: ${({ isMobileApp }) => (isMobileApp ? 'none' : 'normal')};
    @media (hover: hover){
      &:hover{
        color:${CLICKABLE_COLOR} !important;
      }
    }
  }
}

  @media screen and (max-width: 768px) {
    margin: 0 0 1px;
    flex-basis: 100%;

    &:nth-child(2) {
      border-top: 1px solid ${OUTLINE_COLOR};
    }
  }

  @media screen and (max-width: 414px) {
    padding: 2px 0 2px;
    && {
      border-top: none;
    }
  }

`

export const _TitleValueBlock = styled(TitleValueBlockV2)`
  ${titleValueBlockCss}

`

export const _TitleValueBlockHidden = styled(TitleValueBlockV2)`
  ${titleValueBlockCss}
`

export const _ListingDetailKeyContainer = styled(NoPaddingGrid)`
  width: 100%;
  > div {
    &:first-child {
      margin: 0 -6px;
    }
  }

  @media screen and (max-width: 768px) {
    ${({ allShown }) => (!allShown ? `
        ${_TitleValueBlockHidden} {
          display: none;
        }
      ` : '')}
  }

`

export const _ShowButton = styled.div`
  display: none;
  @media (hover: hover){
    &:hover{
      color:${CLICKABLE_COLOR};
    }
  }
  &:active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }
  @media screen and (max-width: 768px) {
    display: inline-block;
    cursor: pointer;
    color: ${CLICKABLE_COLOR};
    margin-top: 8px;
  }
`

